<div class="modal-container">
  <div class="modal-header">
    <div class="row">
      <button type="button" class="close" (click)="cancel()">
        <img src="assets/icons/dismiss-black.svg">
      </button>
    </div>
    <div class="image-n-text">
      <h4 class="title-text">{{ 'Verificação necessária' | translate }}</h4>
      <h4 class="separadorCinzaPadrao mt-6"></h4>
    </div>
  </div>

  <div class="modal-body mb-4">
    <p>{{ 'VERIFICACAO_INFORMACAO_INSTRUCOES' | translate }}</p>

    <div class="factor-list">
      <div *ngFor="let factor of fatores"
           class="factor-item"
           (click)="selectFactor(factor)">
        <div class="factor-icon">
          <img *ngIf="factor.tipo === 'SMS'" src="assets/icons/sms-black.svg">
          <img *ngIf="factor.tipo === 'EMAIL'" src="assets/icons/email-black.svg">
        </div>
        <div class="factor-info">
          <div class="factor-type">{{ factor.tipo }}</div>
          <div class="factor-identifier">
            <span *ngIf="factor.tipo === 'SMS'"> {{ 'Para o número ' | translate}}</span>
            <span *ngIf="factor.tipo === 'EMAIL'"> {{ 'Para ' | translate}}</span>
            {{ factor.identificador }}
          </div>
        </div>

        <div class="arrow-select-factor">
          <img src="assets/icons/arrow-right.svg">
        </div>
      </div>
    </div>
  </div>
</div>
